import React from 'react';

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">이용약관</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">제1조 (목적)</h2>
          <p className="text-gray-600">
            이 약관은 회사가 제공하는 자동 분개 추천 서비스의 이용조건 및 절차, 회사와 회원 간의 권리, 의무 및 책임사항 등을 규정함을 목적으로 합니다.
          </p>
        </section>
        {/* 추가 섹션들... */}
      </div>
    </div>
  );
};

export default Terms;